function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Checkbox, listItemStyles, Menu, Spacer } from "@neru/ui";
import { useRef, useState } from "react";
import { toNameValueObject } from "../../utils/data-mappers";
import { isNotEmpty } from "../../utils/validators";
import { DatePicker } from "../DatePicker/DatePicker";
/**
 * MagicFilterButton expands into two-levels deep menu to filter one at a time
 *
 * @param disabled      Is button disabled.
 * @param busy          Is button disabled and progress indication shown.
 * @param filterData    An object of field names as keys and arrays of available
 *                      values for each field to choose from.
 * @param optionNames   Array of filter option names.
 * @param rules         Types of filter options (date_range, in_range, eq, etc.)
 *                      which determines the way the applied filter is displayed.
 * @param position      Position (LEFT, RIGHT) at which filter menu is expanded.
 */ export var MagicFilterButton = function(param) {
    var _param_busy = param.busy, busy = _param_busy === void 0 ? false : _param_busy, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, filterData = param.filterData, _param_initFormElements = param.initFormElements, initFormElements = _param_initFormElements === void 0 ? function(x) {
        return x;
    } : _param_initFormElements, optionNames = param.optionNames, rules = param.rules;
    var menu = useRef(null);
    var date_range = rules.date_range, in_range = rules.in_range, is_null = rules.is_null;
    var _useState = _sliced_to_array(useState(), 2), fieldName = _useState[0], setFieldName = _useState[1];
    var renderBaseMenu = function() {
        return filterData && Object.entries(optionNames).filter(function(param) {
            var _param = _sliced_to_array(param, 1), action = _param[0];
            var _rules_in_range;
            if ((_rules_in_range = rules.in_range) === null || _rules_in_range === void 0 ? void 0 : _rules_in_range.includes(action)) {
                // Show filter options for not empty data
                return filterData[action] && filterData[action].length !== 0;
            }
            return true;
        }).map(function(param) {
            var _param = _sliced_to_array(param, 2), action = _param[0], name = _param[1];
            return /*#__PURE__*/ _jsx("div", {
                className: listItemStyles,
                onClick: function() {
                    return setFieldName(action);
                },
                onKeyDown: function(e) {
                    if (e.key === "Enter" || e.key === " ") {
                        setFieldName(action);
                    }
                },
                role: "button",
                tabIndex: 0,
                children: name
            }, action);
        });
    };
    var renderMenuOptions = function(filterParam) {
        if (((is_null === null || is_null === void 0 ? void 0 : is_null.includes(filterParam)) || (in_range === null || in_range === void 0 ? void 0 : in_range.includes(filterParam))) && filterData && filterData[filterParam]) {
            var normalizedItems = filterData[filterParam].filter(isNotEmpty).map(toNameValueObject);
            return normalizedItems.map(function(param) {
                var name = param.name, value = param.value;
                return /*#__PURE__*/ _jsx("div", {
                    className: listItemStyles,
                    children: /*#__PURE__*/ _jsx(Checkbox, {
                        label: typeof name === "string" ? name : String(name !== null && name !== void 0 ? name : ""),
                        name: filterParam,
                        value: value
                    })
                }, value);
            }).concat(normalizedItems.length === 1 ? [
                /*#__PURE__*/ _jsx(Checkbox, {
                    className: "hidden",
                    disabled: true,
                    name: filterParam,
                    value: ""
                }, "")
            ] : []); // Add empty checkbox in case single option available
        } else if (date_range === null || date_range === void 0 ? void 0 : date_range.includes(filterParam)) {
            return /*#__PURE__*/ _jsx(DatePicker, {
                date: new Date(),
                name: filterParam,
                showRanges: true
            });
        }
        return null;
    };
    var renderMenuWrapper = function() {
        var _menu_current, _menu_current1;
        if (!fieldName || !filterData) return null;
        return /*#__PURE__*/ _jsxs("div", {
            className: "magic-filter-button",
            "data-testid": "filter-".concat(fieldName),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "border-b border-primary-200 p-4 pt-2",
                    children: optionNames[fieldName]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "max-h-[400px] overflow-scroll py-2",
                    role: "group",
                    children: initFormElements(renderMenuOptions(fieldName))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "\n            flex min-w-max flex-nowrap justify-end whitespace-nowrap border-t\n            border-primary-200 p-4 pb-2\n          ",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            "data-testid": "cancel-filter",
                            label: "Cancel",
                            onClick: (_menu_current = menu.current) === null || _menu_current === void 0 ? void 0 : _menu_current.close,
                            shape: "pill",
                            type: "button"
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "sm"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            "data-testid": "apply-filter",
                            label: "Apply",
                            layout: "outlined",
                            onClick: (_menu_current1 = menu.current) === null || _menu_current1 === void 0 ? void 0 : _menu_current1.close,
                            shape: "pill",
                            type: "submit"
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ _jsx(Menu, {
        "data-testid": "add-filter",
        disabled: busy || disabled,
        icon: busy ? "refresh-line" : "preferences-line",
        label: "Add filter",
        layout: "outlined",
        onClick: function() {
            return setFieldName(undefined);
        },
        ref: menu,
        shape: "pill",
        children: /*#__PURE__*/ _jsx("div", {
            className: "\n          bg-white py-2 text-primary-1000 light\n\n          dark:bg-white\n        ",
            "data-testid": "filter-menu",
            children: fieldName ? renderMenuWrapper() : renderBaseMenu()
        })
    });
};

//# sourceMappingURL=MagicFilterButton.js.map